export function formatDate(inputDate: string) {
  // const inputDate = "2024-02-03T13:44:09.447Z";
  const date = new Date(inputDate);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const day = String(date.getDate()).padStart(2, "0");
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  const formattedDate = `${day} ${months[monthIndex]} ${year}`;
  // Output: 03 Feb 2024
  return formattedDate;
}

export function formatTime(inputTime: string) {
  const [hours, minutes] = inputTime.split(":");
  return `${hours}:${minutes}`;
}

export function formatSinceDate(date: Date) {
  if (!date) return "";
  const d = new Date(date);
  const month = d.toLocaleString("default", { month: "long" });
  const year = d.getFullYear();
  return `${month}, ${year}`;
}
